import { useLanguage } from '../i18n/LanguageContext';

export default function Mediation() {
  const { t } = useLanguage();
  const paragraphs = Array.isArray(t.mediation.paragraphs) ? t.mediation.paragraphs : [];
  const bullets = Array.isArray(t.mediation.bullets) ? t.mediation.bullets : [];
  const links = Array.isArray(t.mediation.links) ? t.mediation.links : [];

  return (
    <div>
      <div className="page-header documents-page">
        <h1>{t.mediation.title}</h1>

        {paragraphs.map((paragraph) => (
          <p key={paragraph}>{paragraph}</p>
        ))}

        {bullets.length > 0 && (
          <section className="document-section">
            <h2>{t.mediation.bulletsTitle}</h2>
            <ul>
              {bullets.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </section>
        )}

        {t.mediation.contactTitle && (
          <section className="document-section">
            <h2>{t.mediation.contactTitle}</h2>
            <p>
              {t.mediation.emailLabel} {t.mediation.email}
            </p>
            <p>
              {t.mediation.phoneLabel} {t.mediation.phone}
            </p>
          </section>
        )}

        {links.length > 0 && (
          <section className="document-section">
            <h2>{t.mediation.linksTitle}</h2>
            <ul>
              {links.map((link) => (
                <li key={link.url}>
                  <a href={link.url} target="_blank" rel="noreferrer">
                    {link.label || link.url}
                  </a>
                </li>
              ))}
            </ul>
          </section>
        )}
      </div>
    </div>
  );
}
